import styled from 'styled-components'

export const FeedbackGifs = styled.div`
    height: 100%;
    width: 100%;
    .masonry {
        columns: 4;
        column-gap: 16px;
        @media (max-width: 1200px) {
            columns: 4;
        }
        @media (max-width: 992px) {
            columns: 2;
        }
        @media (max-width: 768px) {
            columns: 2;
        }
        .grid {
            margin-bottom: 16px;
            position: relative;
            &:before {
                border-radius: 5px;
                content: '';
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                background-color: rgba(0, 0, 0, 0.2);
            }
            img {
                width: 100%;
                border-radius: 5px;
            }
            &__title {
                font-size: 28px;
                font-weight: bold;
                margin: 0px 0px 10px 0px;
            }
            &__author {
                font-size: 14px;
                font-weight: 300;
            }
            &__link {
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
            }
            &__body {
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                padding: 30px 30px;
                color: #fff;
                display: flex;
                flex-direction: column;
            }
            &__tag {
                background-color: rgba(255, 255, 255, 0.8);
                color: #333;
                border-radius: 5px;
                padding: 5px 15px;
                margin-bottom: 5px;
            }
        }
    }
    .mt-auto {
        margin-top: auto;
    }
`

export const Container = styled.div`
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
    max-height: max-content;
    font-family: Avenir;
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;

    @media (max-width: 480px) {
        height: 100vh;
    }
    @media (min-width: 481px) and (max-width: 768px) {
        height: 100vh;
    }
    @media (max-width: 992px) and (orientation: landscape) {
        height: 120vh;
    }
`

export const FeedbackGifWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
`

export const MasonaryWrapper = styled.div`
    width: 80%;
    height: 100%;
    background: #000;
    padding: 0 16px;
    @media (max-width: 768px) {
        width: 100%;
        height: 100%;
    }
`

export const TextCenter = styled.div`
    width: 100%;
    text-align: center;
`
export const Heading = styled.div`
    color: #fff;
    margin: 50px 0px ${props => (props.showFeedback ? '10px' : '40px')};
    font-size: 22px;
    font-family: AvenirBold;
    font-weight: 600;
    @media (max-width: 992px) {
        font-size: 16px;
    }
    @media (max-width: 500px) {
        width: 80%;
        text-align: left;
        margin-top: 45px;
    }
`
export const NextButton = styled.div`
    position: absolute;
    top: 40px;
    right: 11%;
    cursor: pointer;
    height: 50px;
    z-index: 10;
    width: 50px;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-weight: bold;
    background: ${p => (p.active ? '#F3C520' : '#C4C4C4')};
    @media (max-width: 500px) {
        right: 16px;
    }
`
export const NextButtonImage = styled.img`
    width: 30px;
    height: 30px;
`

export const Message = styled.div`
    font-family: AvenirBold;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 40px;
    color: #f3c520;
    ${props =>
        props.isBlinkMessage ? `animation: animate 1.5s linear 2; ` : '30px'};
    @media (max-width: 992px) {
        font-size: 14px;
    }
    @keyframes animate {
        0% {
            opacity: 0;
        }
        50% {
            opacity: 0.7;
        }
        100% {
            opacity: 0;
        }
    }
`
export const Masonary = styled.div`
    columns: 4;
    column-gap: 16px;
    @media (max-width: 1200px) {
        columns: 4;
    }
    @media (max-width: 992px) {
        columns: 2;
    }
    @media (max-width: 768px) {
        columns: 2;
    }
`

export const GifSection = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;

    @media (max-width: 992px) and (orientation: landscape) {
        overflow: auto;
        justify-content: center;
    }
`

export const GifColumn = styled.div`
    height: 75vh;
    display: flex;
    flex-direction: column;
    background: red;
    justify-content: flex-start;
    width: calc(25% - 12px);
    margin-right: 16px;
    margin-bottom: 50px;
    &:last-child {
        margin-right: 0;
    }
    &:nth-child(1) {
        background: #ef5c34;
    }
    &:nth-child(2) {
        background: #58b7e6;
    }
    &:nth-child(3) {
        background: #f3c520;
    }
    &:nth-child(4) {
        background: #95c48c;
    }
    @media (max-width: 500px) {
        width: calc(50% - 8px);
        margin-bottom: 0;
        background: #000;
        &:nth-child(n) {
            background: #000;
        }
    }
`

export const GifBox = styled.div`
    width: 100%;
    height: max-content;
    background: #000;
    padding-bottom: 16px;
`
